import EditButton from './EditBackgroundButton';
import EditButtonContainer from './EditBackgroundButton.container';
export default EditButtonContainer(EditButton);

//# sourceMappingURL=index.js.map